import { GenericObject, copyFields } from '@synergy/models';

import { Account } from './account';

export class Contact {
    public id?: number;
    public fullName!: string;
    public positionName!: string;
    public mainAccountId!: number;
    public accounts!: Account[];
    public email!: string;
    public phone!: string;
    public firstName!: string;
    public lastName!: string;
    public gender!: string;

    public static fromPlainObject(object: GenericObject): Contact {
        const contact = new Contact();

        copyFields(object, contact);

        if (object['accounts']) {
            contact.accounts = object['accounts'].map(Account.fromPlainObject);
        }

        return contact;
    }
}
